// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PriceListEachService_mainWrapper__6lq63","basePrice":"PriceListEachService_basePrice__XeA3b","viewBtn":"PriceListEachService_viewBtn__QlIW-"};